/* 重启 */
import {action, computed} from 'mobx';
import {deviceReboot} from '@/services/Home';
import DeviceStore from '@/stores/device';
import UserStore from '@/stores/user';
import * as R from 'ramda';
import {message} from 'antd';
import log from '@/utils/log';

class RebootStore {
  
  @computed get selectedIds() {
    return DeviceStore.DeviceBaseStore.selectedCids.map(cid =>
      R.find(R.propEq('cid', cid))(DeviceStore.DeviceBaseStore.deviceList
      )).map((r: any) => r.id);
  }
  
  @action.bound selectedId(cid: string) {
    return [cid].map(cid =>
      R.find(R.propEq('cid', cid))(DeviceStore.DeviceBaseStore.deviceList
      )).map((r: any) => r.id);
  }
  
  @action async deviceReboot(cid?: string) {
    
    const [error] = await deviceReboot({
      ids: cid ?  R.join(',', this.selectedId(cid)) :  R.join(',', this.selectedIds),
      groupId: UserStore.GroupStore.activeGroupId
    });
  
  
    if(error) {
      log({ pageId: 'P07', eventId: 'E0703',  ext: ''})
      return false;
    }
    log({ pageId: 'P07', eventId: 'E0700',  ext: ''})
    message.success('操作成功')
    
    await  DeviceStore.DeviceBaseStore.getDeviceList({groupId: UserStore.GroupStore.activeGroupId});
    
    return true
    
  }
  
}

export default RebootStore;
